import { useState, useEffect } from 'react';
import eventBus from '../utils/eventBus';

export function useUserStatus(userId) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!userId) return;

    const handler = (data) => {
      if (data.userId === userId) {
        setStatus(data.status);
      }
    };

    eventBus.on('UPDATE_USER_STATUS', handler);

    return () => {
      eventBus.off('UPDATE_USER_STATUS', handler);
    };
  }, [userId]);

  return status;
}




